export default {
  editor_chatTab_text_messagePlaceholderNamed: 'Message {peer}',
  editor_chatTab_text_messagePlaceholder_meBot: 'Message yourself',
  mediaTray_chatTab_notification_stickerMessage:
    'sent a sticker - {stickerName} ',
};
